import { GuideLine } from "@/app/activity/store/type"
import { Session, SessionData } from "@/types/session"

import { create } from "zustand"
import { devtools } from "zustand/middleware"

export type SessionState = {
  sessions: Session[]
  session?: Session
  temporarySession?: Session
  activeIdfSession?: number
  upsertDialogOpen?: boolean
  confirmSaveDialogOpen?: boolean
  sessionGuideLine?: GuideLine
  hoveredSession?: Session
  sessionDataList: SessionData[]
}

export const initialSessionState: SessionState = {
  sessions: [],
  session: undefined,
  temporarySession: undefined,
  activeIdfSession: undefined,
  upsertDialogOpen: false,
  confirmSaveDialogOpen: false,
  sessionDataList: [],
}

export type SessionStateActions = {
  setSessions: (sessions: Session[]) => void
  setSession: (session?: Session) => void
  setTemporarySession: (temporarySession?: Session) => void
  setActiveIdfSession: (activeIdfSession: number) => void
  setUpsertDialogOpen: (open: boolean) => void
  setConfirmSaveDialogOpen: (open: boolean) => void
  setSessionGuideLine: (sessionGuideLine?: GuideLine) => void
  setHoveredSession: (hoveredSession?: Session) => void
  setSessionDataList: (sessionDataList: SessionData[]) => void
}

export type SessionStore = SessionState & SessionStateActions

export const createSessionStore = create<SessionStore>()(
  devtools(
    (set) => ({
      ...initialSessionState,
      setSessions: (sessions: Session[]) => {
        set({ sessions }, undefined, "setSessions")
      },
      setSession: (session?: Session) => {
        set({ session }, undefined, "setSession")
        if (session) {
          set({ activeIdfSession: session.idfSession }, undefined, "setActiveIdfSession")
        }
      },
      setTemporarySession: (temporarySession?: Session) => {
        set({ temporarySession }, undefined, "setTemporarySession")
      },
      setActiveIdfSession: (activeIdfSession: number) => {
        set({ activeIdfSession }, undefined, "setActiveIdfSession")
      },
      setUpsertDialogOpen: (upsertDialogOpen: boolean) => {
        set({ upsertDialogOpen }, undefined, "setUpsertDialogOpen")
      },
      setConfirmSaveDialogOpen: (confirmSaveDialogOpen: boolean) => {
        set({ confirmSaveDialogOpen }, undefined, "setConfirmSaveDialogOpen")
      },

      setSessionGuideLine: (sessionGuideLine?: GuideLine) => {
        set({ sessionGuideLine }, undefined, "setSessionGuideLine")
      },
      setHoveredSession: (hoveredSession?: Session) => {
        set({ hoveredSession }, undefined, "setHoveredSession")
      },
      setSessionDataList: (sessionDataList: SessionData[]) => {
        set({ sessionDataList }, undefined, "setSessionDataList")
      },
    }),
    {
      store: "session",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
